import { render, staticRenderFns } from "./addConfig.vue?vue&type=template&id=604cba0a"
import script from "./addConfig.vue?vue&type=script&lang=js"
export * from "./addConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports